import React from "react";
import './c39_image_carousel_ui.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class ImageCarouselUI extends TemplateComponent {
    constructor(props) {
        super(props)
        this.state = {
            slideIndex: 1,
            updateCount: 0
        }
    }

    componentRender(data) {
        const settings = {
            dots: false,
            infinite: true,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            cssEase: "linear",
            afterChange: (index) => this.setState(state => ({slideIndex: state.updateCount + (index + 1)})),
            beforeChange: (current, next) => this.setState({slideIndex: next}),
            responsive: [
                {
                    breakpoint: 415,
                    settings: {
                        centerMode: true,
                        centerPadding: "30px",
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        centerMode: true,
                        centerPadding: "12px",
                    }
                }
            ]
        };

        return (
            <div id={!isMobileOnly ? 'img-carousel-ui' : 'img-carousel-ui-mob'}>
                <div className="conainer">
                    <div className="row">
                        <div className="col-12 mx-auto">
                            <Slider ref={slider => (this.slider = slider)} {...settings}>
                                {data.gallery.map((img, index) => (
                                    <div key={index}>
                                        <img src={img.image} alt={img.alt}/>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="slider-fraction">
                    <span>{this.state.slideIndex}</span><span>/{data.gallery.length}</span>
                </div>
                <div className="slidecontainer">
                    <input
                        className="progressive-slider"
                        onChange={event => {this.slider.slickGoTo(event.target.value)}}
                        value={this.state.slideIndex}
                        type="range"
                        min="1"
                        max={data.gallery.length}
                    />
                </div>
            </div>
        )
    }
}

export default ImageCarouselUI;
